export default __webpack_public_path__ + "static/media/progress.8e5420c1.svg";